import {
    FETCH_TRAINING_STATUS_WEEKLY_DATA,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS,
    FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    trainingStatusReportData: null,
    isFetching: false,
    fetchFailed: false
};

const fetchTrainingStatusReportDataFetching = (state) => {
    return {
        ...state,
        isFetching: true,
        fetchFailed: false
    };
};

const fetchTrainingStatusReportDataSuccess = (state, action) => {
    return {
        trainingStatusReportData: action.data?.reportData,
        isFetching: false,
        fetchFailed: false
    };
};

const fetchTrainingStatusReportDataFail = (state, action) => {
    return {
        trainingStatusReportData: action.data,
        isFetching: false,
        fetchFailed: true
    };
};

const handlers = {
    [FETCH_TRAINING_STATUS_WEEKLY_DATA_FETCHING]: fetchTrainingStatusReportDataFetching,
    [FETCH_TRAINING_STATUS_WEEKLY_DATA_SUCCESS]: fetchTrainingStatusReportDataSuccess,
    [FETCH_TRAINING_STATUS_WEEKLY_DATA_FAIL]: fetchTrainingStatusReportDataFail
};

export default function trainingStatusReport(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

export const getTrainingStatusReportData = (state) => {
    return state.trainingStatusReport.trainingStatusReportData &&
        Object.keys(state.trainingStatusReport.trainingStatusReportData).length > 0
        ? state.trainingStatusReport.trainingStatusReportData
        : null;
};

export const isTrainingStatusReportDataFetching = (state) => {
    return state.trainingStatusReport?.isFetching;
};

export const isTrainingStatusReportDataFetchFailed = (state) => {
    return state.trainingStatusReport?.fetchFailed;
};

// Actions
export function fetchTrainingStatusReportData(payload, evictCache) {
    return {
        type: FETCH_TRAINING_STATUS_WEEKLY_DATA,
        payload,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}
